import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import useGetCensusParams from "./GetCensusParams";
import { useLayerService } from "../../../../../hooks";
import { CensusOutputAreaType } from "../../../../../types/Census/CensusOutputAreaType";
import StyledToggle from "../../../../boundarySelection/ViewTools/StyledToggle";
import CensusUrlKeys from "../../../../../constant/CensusUrlKeys";

const OutputAreaDropdown = () => {
  const layerService = useLayerService();
  const [outputAreas, setOutputAreas] = useState<CensusOutputAreaType[]>([]);
  const { year, outputAreaId, handleSelect } = useGetCensusParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!year) return;
    setLoading(true);
    layerService.GetCensusOutputAreaTypes(year).then((response) => {
      setOutputAreas(response);
      setLoading(false);
      if (outputAreaId === null && response.length > 0) {
        const lowest = response.reduce((a, b) =>
          a.outputAreaTypeId < b.outputAreaTypeId ? a : b,
        );
        handleSelect(CensusUrlKeys.OUTPUT_AREA, lowest.outputAreaTypeId);
      }
    });
  }, [year]);

  const handleChange = (selectedOutputArea: string | null) => {
    handleSelect(CensusUrlKeys.OUTPUT_AREA, Number(selectedOutputArea));
  };

  const selectedArea = outputAreas.find(
    (o) => o.outputAreaTypeId === outputAreaId,
  );

  return (
    <Dropdown onSelect={handleChange}>
      <StyledToggle
        disabled={outputAreas.length === 0 || loading}
        className="view-tools-dropdown fs-6 bg-light text-black"
        size="lg"
      >
        <span className="toggle-text">
          {loading ?
            "Loading..."
          : outputAreaId === null || outputAreas.length === 0 ?
            "Select Output Area Type"
          : selectedArea?.name}
        </span>
      </StyledToggle>

      <Dropdown.Menu className="w-100 fs-6">
        {outputAreas.map((y) => (
          <Dropdown.Item
            key={y.outputAreaTypeId}
            eventKey={String(y.outputAreaTypeId)}
            active={y.outputAreaTypeId === outputAreaId}
          >
            {y.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default OutputAreaDropdown;
